
const UrlManager = {
    install: function (Vue) {
        Vue.prototype.$ApiUrlManager = {
            InitDepositData: "/api/DepositRequest/InitDepositData",
            GetSecurityCenterData: "/api/AccountCenter/GetSecurityCenterData"
        };
    }
};


export default UrlManager;